// Cromado del asistente, en un sitio.
//
// Son los mismos tonos que `NuevaCargaDrawer`: en esta pantalla el usuario ya
// abre un cajón lateral, y la consistencia gana a la novedad. Están aquí y no
// repetidos en cada paso porque cinco copias de la misma paleta divergen a la
// primera que alguien toca una.
export function cromado(dark: boolean) {
  return {
    bg: dark ? 'bg-[#0b0f16]' : 'bg-white',
    border: dark ? 'border-white/[0.07]' : 'border-slate-200',
    mainTxt: dark ? 'text-slate-100' : 'text-slate-900',
    mutedTxt: dark ? 'text-slate-400' : 'text-slate-500',
    dimTxt: dark ? 'text-slate-600' : 'text-slate-400',
    panel: dark ? 'bg-white/[0.03]' : 'bg-slate-50',
    panelBorde: dark ? 'border-white/[0.06]' : 'border-slate-200',
    campo: dark
      ? 'bg-white/[0.04] border-white/10 text-slate-200 placeholder:text-slate-600'
      : 'bg-white border-slate-300 text-slate-800 placeholder:text-slate-400',
  }
}

export const etiquetaCls = 'text-[10px] font-semibold uppercase tracking-wide'

export function campoCls(dark: boolean, invalido = false): string {
  const c = cromado(dark)
  return [
    'w-full px-2.5 py-1.5 rounded-lg border text-[12px] transition-colors',
    'focus:outline-none focus:ring-2 focus:ring-sky-500/30 focus:border-sky-500',
    invalido ? 'border-red-500/70' : '',
    c.campo,
  ].filter(Boolean).join(' ')
}

/** Pastilla de un grupo de opciones (grupo de cliente, almacén).
 *
 *  Se eligen con un clic y se ven todas a la vez: con tres opciones, un
 *  desplegable esconde dos de ellas y obliga a abrirlo para saber qué hay. */
export function pastillaCls(dark: boolean, activa: boolean): string {
  if (activa) return 'px-3 py-1.5 rounded-lg text-[12px] font-semibold bg-sky-600 text-white cursor-pointer'
  return [
    'px-3 py-1.5 rounded-lg text-[12px] font-medium cursor-pointer transition-colors',
    dark
      ? 'bg-white/[0.05] text-slate-400 hover:bg-white/[0.09] hover:text-slate-200'
      : 'bg-slate-100 text-slate-500 hover:bg-slate-200 hover:text-slate-700',
  ].join(' ')
}

/** Chip de aviso de una línea. Son avisos, no errores: la línea pasa igual. */
export function chipCls(dark: boolean, tono: 'aviso' | 'info' | 'nuevo'): string {
  const base = 'px-1.5 py-0.5 rounded text-[9px] font-semibold uppercase tracking-wide whitespace-nowrap'
  if (tono === 'aviso') {
    return `${base} ${dark ? 'bg-amber-500/15 text-amber-400' : 'bg-amber-100 text-amber-700'}`
  }
  if (tono === 'nuevo') {
    return `${base} ${dark ? 'bg-fuchsia-500/15 text-fuchsia-400' : 'bg-fuchsia-100 text-fuchsia-700'}`
  }
  return `${base} ${dark ? 'bg-sky-500/15 text-sky-400' : 'bg-sky-100 text-sky-700'}`
}
